import { Widget, WidgetTour, WidgetTourStep } from "../../types";
import BaseController from "./BaseController";

// Builder-mode requests carry a short-lived, tour-scoped token (minted by
// the admin's "Edit on your website" button) instead of visitor identity -
// BaseController.post still works fine here since the extra app_id/device
// fields it attaches are simply ignored server-side.
class TourBuilderController extends BaseController {
  static getTour(token: string): Promise<{ tour: WidgetTour, widget: Widget }> {
    return this.post("messenger/tour_builder/tour", { token })
  }

  static updateTour(token: string, tour: Partial<WidgetTour>): Promise<WidgetTour> {
    return this.post("messenger/tour_builder/tour/update", { token, tour })
  }

  static createStep(token: string, step: Partial<WidgetTourStep>): Promise<WidgetTourStep> {
    return this.post("messenger/tour_builder/steps/create", { token, step })
  }

  static updateStep(token: string, step: Partial<WidgetTourStep>): Promise<WidgetTourStep> {
    return this.post("messenger/tour_builder/steps/update", { token, id: step.id, step })
  }

  static deleteStep(token: string, id: string): Promise<WidgetTourStep> {
    return this.post("messenger/tour_builder/steps/delete", { token, id })
  }

  static reorderSteps(token: string, orderedIds: string[]): Promise<WidgetTourStep[]> {
    return this.post("messenger/tour_builder/steps/reorder", { token, ordered_ids: orderedIds })
  }
}

export default TourBuilderController
